import { Space } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import StickyPageHeader from '../components/common/StickyPageHeader';
import RatesFilter from '../components/filters/RatesFilter';
import RateTable from '../components/tables/RateTable';
import { useCarriers, useDefaultModes, useShipTypes } from '../hooks/apiHooks';
import { useRates } from '../hooks/apiHooks/rate';
import Layout from '../layout';

const AdminRatesPage = ({ disableLayout, routes }) => {
  const { allCarriers, isLoading: isCarriersLoading } = useCarriers();
  const { allShipTypes } = useShipTypes();
  const { defaultModes } = useDefaultModes();
  const [filter, setFilter] = useState(null);
  const { isLoading: isRatesLoading, rates } = useRates(undefined, filter);
  const [highlightRateId, setHighlightRateId] = useState(null);

  useEffect(() => {
    if (highlightRateId) {
      const timer = setTimeout(() => setHighlightRateId(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [highlightRateId]);

  const handleClearFiltersAndGoToRate = useCallback((rateId) => {
    setFilter(null);
    setHighlightRateId(rateId);
  }, []);

  const isTableLoading = useMemo(
    () => isCarriersLoading || (isRatesLoading && !rates.length),
    [isCarriersLoading, isRatesLoading, rates.length]
  );

  const content = (
    <>
      <StickyPageHeader isAdmin title="Rates" />
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <RatesFilter
          showAllCarriers
          carriers={allCarriers}
          filter={filter}
          modes={defaultModes}
          onFilterChange={setFilter}
        />
        <RateTable
          showAllCarriers
          carriers={allCarriers}
          customEmptyText={!filter ? 'No filters selected' : false}
          highlightRateId={highlightRateId}
          loading={isTableLoading}
          rates={isTableLoading ? [] : rates}
          selectedCarrier={null}
          shipTypes={allShipTypes}
          onClearFiltersAndGoToRate={handleClearFiltersAndGoToRate}
        />
      </Space>
    </>
  );

  if (disableLayout) return content;

  return (
    <Layout disableLoading showCarriersNavigation skipFullPageLoader menuIndex={0} routes={routes}>
      {content}
    </Layout>
  );
};

export default AdminRatesPage;
